module.exports = __webpack_public_path__ + "static/media/banner_380x240.0252ed70.jpg";